import { type ReactNode } from "react";
import { formatTrustRegNo } from "@/utils/tenant-trust-subtitle";

type TenantTrustSubTitleProps = {
  trustName: string;
  trustId: string;
};

/** Trust name and registration lines for receipt headers. */
export function TenantTrustSubTitle({ trustName, trustId }: TenantTrustSubTitleProps) {
  const reg = formatTrustRegNo(trustId);
  const name = trustName.trim();

  if (!name && !reg) return null;

  return (
    <>
      {name}
      {name && reg ? <br /> : null}
      {reg}
    </>
  );
}

export function combineReceiptSubTitle(
  trustName: string,
  trustId: string,
  extra?: ReactNode
): ReactNode {
  const trustLines = <TenantTrustSubTitle trustName={trustName} trustId={trustId} />;
  const hasTrust = Boolean(trustName.trim() || trustId.trim());

  if (!extra) {
    return hasTrust ? trustLines : null;
  }

  if (!hasTrust) {
    return extra;
  }

  return (
    <>
      {trustLines}
      <br />
      {extra}
    </>
  );
}

export function combineReceiptSubTitleText(
  trustName: string,
  trustId: string,
  extra?: string
): string {
  const lines = [trustName.trim(), formatTrustRegNo(trustId), extra?.trim()].filter(Boolean);
  return lines.join("\n");
}
